import { Typography } from "@material-ui/core"
import { ImageVideoModel } from "api"
import VideoModal from "components/carModelPage/reusable/VideoModal"
import styled from "styled-components"
import colors from "theme/colors"
import { TypographyCenter } from "theme/shared"
const StyledSectionWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.black};
  justify-content: center;
  gap: 60px;
  padding: 80px 0px 52px;
`
const StyledVideoCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 60px;
  }
`
const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  max-width: 650px;
  margin: 0 auto;
  padding: 0 16px;
`
const StyledDescription = styled(Typography).attrs({ variant: "body1" })`
  word-break: bread-word;
  color: ${(p) => p.theme.colors.white};
  text-align: center;
`
type InsideHighLightsProps = {
  data: ImageVideoModel[]
}

const InsideHighLights = ({ data }: InsideHighLightsProps) => {
  return (
    <StyledSectionWrapper>
      {data?.map((item, index) => (
        <StyledVideoCard key={`InsideHighLights-${index}`}>
          <StyledTextWrapper>
            <TypographyCenter variant="h2" $color={colors.white}>
              {item.name}
            </TypographyCenter>
            <StyledDescription>{item.description}</StyledDescription>
          </StyledTextWrapper>
          <VideoModal
            src={item.videoUrl}
            imgDesktop={item.imageUrl}
            imgMobile={item.imageUrl}
            alt={item.alt}
            height={"440px"}
          />
        </StyledVideoCard>
      ))}
    </StyledSectionWrapper>
  )
}

export default InsideHighLights
